import styled from 'styled-components';

import { Icon } from '@pb/shared/ui/atoms/icon';

export const StyledConnectionIssues = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0.8rem 1.2rem;
    color: ${({ theme }) => theme.color.white};
    background: ${({ theme }) => theme.color.red};
`;

export const StyledSpan = styled.span`
    margin-left: 0.8rem;
`;

export const StyledIcon = styled(Icon)`
    flex: 0 0 2.4rem;
`;
